import React from 'react';
import { Link } from '@tanstack/react-router';
import { Table } from '@tanstack/react-table';
import { ChecklistQueryData } from '@area-restrita/api-client/model/checklistQueryData';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import DataGrid from '@/components/DataGrid';

interface IProps {
  table: Table<ChecklistQueryData>;
  isLoading: boolean;
}

const CheckListSettingsView: React.FC<IProps> = ({ table, isLoading }) => (
  <Card>
    <CardHeader>
      <CardTitle>Check List</CardTitle>
      <CardDescription></CardDescription>
    </CardHeader>

    <CardContent className="p-0">
      <DataGrid
        table={table}
        isLoading={isLoading}
        actions={
          <Link to="/settings/hang-tag/check-list/new">
            <Button size="sm">Criar Check List</Button>
          </Link>
        }
      />
    </CardContent>
  </Card>
);

export default CheckListSettingsView;
